import { render, staticRenderFns } from "./NotificationsView.vue?vue&type=template&id=35981ca4&"
import script from "./NotificationsView.vue?vue&type=script&lang=ts&"
export * from "./NotificationsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports